module.exports = "<dynamic-component *ngIf=\"component\" [component]=\"component\" [setData]=\"setData\" [compile]=\"true\"></dynamic-component>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/authorized/environmentDetails/environment-databases/database-properties/database-properties.component.html
// module id = 1741
// module chunks = 0